import {
  RESET_DATE_RANGE,
  RESET_END_DATE,
  SAVE_DATE_RANGE,
  SAVE_END_DATE,
} from "../utils/constants";

const initialState = {
  filter_week: 52,
  end_date: "",
};

const dateRangeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_DATE_RANGE:
      return {
        ...state,
        filter_week: action.payload || null,
      };
    case RESET_DATE_RANGE:
      return {
        ...initialState,
      };
    case SAVE_END_DATE:
      return {
        ...state,
        end_date: action.payload || null,
      };
    case RESET_END_DATE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default dateRangeReducer;
